import React from 'react';
import './AvatarPicker.css';
import { changelogHistory } from './changelogData';

export default function ChangelogModal({ onClose }) {
  return (
    <div className="avatar-modal-overlay" onClick={onClose} style={{ zIndex: 9999 }}>
      <div 
        className="avatar-modal-content glass-panel" 
        onClick={(e) => e.stopPropagation()} 
        style={{ 
          maxWidth: '600px', 
          width: '90%',
          maxHeight: '80vh', 
          display: 'flex', 
          flexDirection: 'column' 
        }}
      >
        <div className="modal-header">
          <h2 className="panel-title" style={{ margin: 0, color: '#facc15' }}>Changelog</h2>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>

        <div className="custom-scrollbar" style={{ padding: '20px', overflowY: 'auto', flex: 1, color: '#e2e8f0', textAlign: 'left', lineHeight: '1.6' }}>
          
          {changelogHistory.map((release, index) => (
            <div key={release.version} style={{ marginBottom: index === changelogHistory.length - 1 ? '0' : '40px' }}>
              
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '2px solid rgba(212,175,55,0.3)', paddingBottom: '10px', marginBottom: '20px' }}>
                <h2 style={{ margin: 0, color: '#facc15', fontSize: '1.5rem' }}>v{release.version}</h2>
                <span style={{ color: '#94a3b8', fontSize: '0.9rem' }}>{release.date}</span>
              </div>
              
              {release.sections.map((section, sIdx) => (
                <div key={sIdx} style={{ marginBottom: '24px' }}>
                  <h3 style={{ color: '#d4af37', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '8px', marginTop: 0 }}>
                    {section.title}
                  </h3>
                  <ul style={{ paddingLeft: '20px', margin: '10px 0' }}>
                    {section.items.map((item, iIdx) => (
                      <li key={iIdx} style={{ marginBottom: '8px' }}>
                        {item.bold && <strong style={{ color: '#f1f5f9' }}>{item.bold}</strong>}
                        {item.text}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
              
            </div>
          ))}

        </div>
      </div>
    </div>
  );
}
